import React, { useEffect, useState } from "react";
import {
  getLicensedSponsorStatus,
  LICENSED_SPONSOR_DISCLAIMER,
} from "../../services/licensedSponsorService";

export default function LicensedSponsorBadge({ companyName, status }) {
  const [lookup, setLookup] = useState(status || null);

  useEffect(() => {
    let cancelled = false;

    if (status) {
      setLookup(status);
      return undefined;
    }

    if (!companyName) return undefined;

    getLicensedSponsorStatus(companyName).then((nextStatus) => {
      if (!cancelled) setLookup(nextStatus);
    });

    return () => {
      cancelled = true;
    };
  }, [companyName, status]);

  if (!companyName || lookup?.is_licensed_sponsor !== true) return null;

  const helperText = lookup.disclaimer || LICENSED_SPONSOR_DISCLAIMER;

  return (
    <span
      className="inline-flex items-center rounded-full border border-amber-300 bg-gradient-to-r from-amber-50 via-yellow-50 to-orange-100 px-3 py-1 text-xs font-semibold text-amber-800 shadow-sm"
      title={helperText}
    >
      Licensed Sponsor
    </span>
  );
}
